import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import useFetch from "../../hooks/useFetch";
import config from "../../config";

import "./SponsorsPage.css";
import DefaultPage from "../DefaultPage/DefaultPage";
import Loader from "../../components/Loader";

const SponsorsPage = () => {
  //fetch stránky (uvod)
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(`${config.api}/api/sponsors-page?populate=background`);

  //fetch sponzoru
  const { loading, error, data } = useFetch(
    `${config.api}/api/sponsors?populate[0]=logo`
  );

  // možné stavy při/po fetchi
  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání sponzorů" />;

  //? test
  //? console.log(data);

  //změna titulku stránky v prohlížeči
  document.title = dataIntroduction.data.title;
  return (
    <div className="min-height-100 d-flex flex-column">
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background p-5">
          <div className="d-flex justify-content-center flex-wrap">
            {data.data.map((sponsor) => (
              <a
                key={sponsor.id}
                href={sponsor.url}
                className="sponsor-item col-10 col-sm-6 col-md-4 col-lg-2 ms-3 me-3"
              >
                <img
                  src={`${config.api}${sponsor.logo.url}`}
                  alt={sponsor.name}
                  className="container-fluid"
                />
                <div className="sponsor-heading">
                  <h5 className="">{sponsor.name}</h5>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default SponsorsPage;
